import moment from "moment";

export function checkUndefined(content, type) {
    if (content === '' || content === null || content === undefined) {
        switch (type) {
            case 'amount':
            case 'balance':
            case 'csv':
                return 0;
            default:
                return ''
        }
    } else {
        switch (type) {
            case 'id':
                return content.id;
            case 'amount':
                return content.amount.toFixed(1);
            case 'balance':
                return content.balance.toFixed(1);
            case 'employee_name':
                return content.employee_name;
            default:
                return content
        }
    }
}

export function toNativeDate(date) {
    return new Date(date.year, date.month - 1, date.day);
}

export function rangeToDayConverter(date1, date2) {
    const itr = moment.twix(new Date(date1), new Date(date2)).iterate("days");
    let range = [];
    while (itr.hasNext()) {
        range.push(itr.next().format(window.global.momentFormat))
    }
    return range;
}

export function getDifferenceInDate(date1, date2) {
    const diffInMs = Math.abs(date2 - date1);
    return diffInMs / (1000 * 60 * 60 * 24);
}

export const minimumUntilDate = ({
    year: new Date().getFullYear(),
    month: new Date().getMonth() + 1,
    day: new Date().getDate()
});

export function decimal(value, isExport = true) {
    let result;
    if (typeof value === 'string' || typeof value === 'number') {
        result = Number(value).toFixed(1)
    } else {
        if (isExport) {
            result = ''
        } else {
            result = '-'
        }
    }
    return result;
}

export function formatDateTimeHours(leaveRecord, key, intl) {
    const newApplicationIntl = 'new_application.';
    const patterns = window.global.patterns;
    const isContainsPatterns = patterns.some(term => leaveRecord.start_time.includes(term));

    switch (key) {
        case 'startDate': {
            if (isContainsPatterns) {
                return `${moment(leaveRecord.start_date).format(window.global.displayFormat)} ${intl.formatMessage({ id: newApplicationIntl + leaveRecord.start_time })}`;
            }
            const startTime = moment(leaveRecord.start_time, 'HH:mm:ss');
            return `${moment(leaveRecord.start_date).format(window.global.displayFormat)} ${startTime.format(window.global.displayTimeFormat)}`;
        }
        
        case 'startTime': {
            if (isContainsPatterns) {
                return `${intl.formatMessage({ id: newApplicationIntl + leaveRecord.start_time })}`;
            }
            const startTime = moment(leaveRecord.start_time, 'HH:mm:ss');
            return `${startTime.format(window.global.displayTimeFormat)}`;
        }

        case 'untilDate': {
            if (isContainsPatterns) {
                return `${moment(leaveRecord.until_date).format(window.global.displayFormat)} ${intl.formatMessage({ id: newApplicationIntl + leaveRecord.end_time })}`;
            }
            const endTime = moment(leaveRecord.end_time, 'HH:mm:ss');
            return `${moment(leaveRecord.until_date).format(window.global.displayFormat)} ${endTime.format(window.global.displayTimeFormat)}`;
        }
        
        case 'endTime': {
            if (isContainsPatterns) {
                return `${intl.formatMessage({ id: newApplicationIntl + leaveRecord.end_time })}`;
            }
            const endTime = moment(leaveRecord.end_time, 'HH:mm:ss');
            return `${endTime.format(window.global.displayTimeFormat)}`;
        }

        case 'period':
            if (isContainsPatterns) {
                return `${leaveRecord?.period?.toFixed(1)} ${intl.formatMessage({id: 'new_application.days'})}`;
            }
            return `${leaveRecord?.hours?.toFixed(1)} ${intl.formatMessage({id: 'comp_leave.hours'})}`;

        default:
            console.error(`Unexpected key: ${key}`);
            return null;
    }
}

export function checkIsNewCompLeave(data) {
    const patterns = window.global.patterns;
    const isContainsPatterns = patterns.some(term => data.includes(term));
    const isNewCompLeave = !isContainsPatterns;
    return isNewCompLeave;
}

export function setLocalStorageSettings(settings) {
    for (const key in settings) {
        localStorage.setItem(key, settings[key]);
    }
}

export function checkIsTabletDevice() {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    const isWindows = /Windows/.test(userAgent);
    const isIpad = /iPad|Macintosh/.test(userAgent);

    const supportsTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 1;
    const screenWidth = window.screen.width * window.devicePixelRatio;
    const screenHeight = window.screen.height * window.devicePixelRatio;
    const isScreenSizeTabletLike = (screenWidth >= 1200 && screenHeight >= 800);

    const isWindowTablet = isWindows && supportsTouch && isScreenSizeTabletLike;
    const isIpadTablet = isIpad && 'ontouchend' in document;

    return isWindowTablet || isIpadTablet;
} 

export function compareEvents(a, b) {
    const dateDiff = moment(a.start).diff(moment(b.start));
    if (dateDiff !== 0) {
        return dateDiff;
    }

    const isA_AM = isAM(a.start_time, a.end_time);
    const isB_AM = isAM(b.start_time, b.end_time);

    if (isA_AM && !isB_AM) {
        return -1;
    } else if (!isA_AM && isB_AM) {
        return 1;
    }

    return compareTimes(a.start_time, b.start_time);
}

export function isAM(startTime, endTime) {
    const parsedStartTime = parseTime(startTime);
    const parsedEndTime = parseTime(endTime);
    const duration = moment.duration(parsedEndTime.diff(parsedStartTime)).asHours();
    
    if (startTime === 'AM' && endTime === 'AM') return true;
    if (startTime === 'PM' && endTime === 'PM') return false;

    if (parsedEndTime.isSameOrBefore(moment('13:00:00', 'HH:mm:ss')) && duration < 8) {
        return true;
    }

    return false;
}

export function parseTime(time) {
    if (time === 'AM') {
        return moment('00:00', 'HH:mm');
    } else if (time === 'PM') {
        return moment('13:00', 'HH:mm');
    }
    return moment(time, 'HH:mm');
}

export function compareTimes(time1, time2) {
    const moment1 = parseTime(time1);
    const moment2 = parseTime(time2);

    if (moment1.isBefore(moment2)) {
        return -1;
    } else if (moment1.isAfter(moment2)) {
        return 1;
    }
    return 0;
}

export function capitalizeFirstLetter(str) {
    if (!str) {
        return '';
    }

    return str.toLowerCase().split(' ').map(word =>
        word.charAt(0).toUpperCase() + word.slice(1)
    ).join(' ');
}

// Time overlap checking function for AM/PM and specific time formats
export const checkTimeOverlap = (newStartDate, newStartTime, newEndDate, newEndTime, existingApplications) => {
    const convertTimeToDateTime = (date, time) => {
        if (time === 'AM') {
            return moment(`${date} 09:00`, 'YYYY-MM-DD HH:mm');
        } else if (time === 'PM') {
            return moment(`${date} 14:00`, 'YYYY-MM-DD HH:mm');
        } else {
            const cleanTime = time.replace(':00', '').substring(0, 5);
            return moment(`${date} ${cleanTime}`, 'YYYY-MM-DD HH:mm');
        }
    };

    const getEndTimeForPeriod = (startDate, startTime, endDate, endTime) => {
        if (endTime === 'AM') {
            return moment(`${endDate} 13:00`, 'YYYY-MM-DD HH:mm');
        } else if (endTime === 'PM') {
            return moment(`${endDate} 18:00`, 'YYYY-MM-DD HH:mm');
        } else {
            const cleanTime = endTime.replace(':00', '').substring(0, 5);
            return moment(`${endDate} ${cleanTime}`, 'YYYY-MM-DD HH:mm');
        }
    };

    const newStart = convertTimeToDateTime(newStartDate, newStartTime);
    const newEnd = getEndTimeForPeriod(newStartDate, newStartTime, newEndDate, newEndTime);

    for (const app of existingApplications) {
        const existingStart = convertTimeToDateTime(app.start_date, app.start_time);
        const existingEnd = getEndTimeForPeriod(app.start_date, app.start_time, app.until_date, app.end_time);

        if (newStart.isBefore(existingEnd) && newEnd.isAfter(existingStart)) {
            return true;
        }
    }

    return false;
};